import { provideTaiga } from "@taiga-ui/core";
import {provideAnimations} from "@angular/platform-browser/animations";
import { ApplicationConfig, provideZoneChangeDetection, signal } from '@angular/core';
import {provideRouter} from '@angular/router';
import {routes} from './app.routes';
import {provideToastr} from 'ngx-toastr';
import {provideHttpClient, withInterceptors} from '@angular/common/http';
import {errorInterceptor} from './shared/interceptors/error.interecepter';
import {mainInterceptor} from './shared/interceptors/main.interceptor';
import {TUI_LANGUAGE, TUI_RUSSIAN_LANGUAGE} from '@taiga-ui/i18n';
import {of} from 'rxjs';

export const appConfig: ApplicationConfig = {
  providers: [
    provideAnimations(),
    provideHttpClient(
      withInterceptors([mainInterceptor, errorInterceptor])
    ),
    provideToastr(),
    provideZoneChangeDetection({eventCoalescing: true}),
    provideRouter(routes),
    provideTaiga({mode: 'light'}),
    {
      provide: TUI_LANGUAGE,
      useValue: signal(TUI_RUSSIAN_LANGUAGE),
    }
  ]
};
